"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M7.5691 10.0001H16.9151C17.7781 10.0001 18.2951 10.9611 17.8181 11.6821L14.9581 16.0001H3.0641L6.7441 10.4431C6.9271 10.1671 7.2371 10.0001 7.5691 10.0001ZM5.076 9.339L2 13.985V5.8C2 5.469 2.256 5.2 2.571 5.2H2.642C2.919 5.2 3.142 4.976 3.142 4.7V4.6C3.142 4.269 3.398 4 3.714 4H7.142C7.458 4 7.714 4.269 7.714 4.6V4.7C7.714 4.976 7.938 5.2 8.214 5.2H15.429C15.744 5.2 16 5.469 16 5.8V8H7.569C6.563 8 5.632 8.501 5.076 9.339Z",
    fill: "#727B7F"
  }));
};